<template>
	<div class="chart-ranger">
		<div class="chart-axis">
			<div v-for="range in sourceRanges">
				{{ range.from }}
			</div>
			<div>
				{{ sourceRanges[sourceRanges.length - 1].toText }}
			</div>
		</div>
		<div class="svg-wrapper" v-html="chartSvg"></div>
		<van-slider
			class="range-slider"
			:max="sourceRanges[sourceRanges.length - 1].to"
			:min="sourceRanges[0].from"
			range
			v-model="sliderRanges"
			@change="onSliderChange"
		/>

		<div class="range-input-row">
			<div class="range-input">
				<input
					v-model="inputRanges[0]"
					:placeholder="sourceRanges[0].from"
					@change="e => onInputChange(e, 0)"
				/>
			</div>
			<span>-</span>
			<div class="range-input">
				<input
					v-model="inputRanges[1]"
					:placeholder="sourceRanges[sourceRanges.length - 1].toText"
					@change="e => onInputChange(e, 1)"
				/>
			</div>
		</div>
	</div>
</template>

<script>
const sourceRangeMap = {
	price: [
		{ from: 0, to: 10 },
		{ from: 10, to: 20 },
		{ from: 20, to: 30 },
		{ from: 30, to: 40 },
		{ from: 40, to: 50, toText: '50+' }
	],
	age: [
		{ from: 0, to: 1 },
		{ from: 1, to: 2 },
		{ from: 2, to: 3 },
		{ from: 3, to: 4, toText: '4+' }
	],
	mileage: [
		{ from: 0, to: 3 },
		{ from: 3, to: 6 },
		{ from: 6, to: 9 },
		{ from: 9, to: 12, toText: '12+' }
	]
}

export default {
	name: 'ChartRanger',
	props: ['type', 'range'],
	data() {
		const sourceRanges = sourceRangeMap[this.type]

		return {
			sourceRanges,
			sliderRanges: [sourceRanges[0].from, sourceRanges[sourceRanges.length - 1].to],
			inputRanges: [null, null],
			cacheInputRages: [null, null]
		}
	},
	mounted() {},
	computed: {
		chartSvg() {
			// echarts width: 527 height: 630
			const pathMap = {
				price:
					'M52.7 86C52.7 86 77.3396 86 99.95 85.064C124.5896 84.044 122.9623 64.576 147.2 64.576C170.2123 64.576 170.5749 72.0363 194.45 77.16C217.8249 82.1763 241.7 84.856 241.7 84.856L241.7 86L194.45 86L147.2 86L99.95 86L52.7 86Z',
				mileage:
					'M52.7 61.4444C52.7 61.4444 84.2812 65.6467 115.7 70.8333C147.2812 76.0467 146.9564 79.8973 178.7 82.2444C209.9564 84.5556 241.7 84.5556 241.7 84.5556L241.7 86L178.7 86L115.7 86L52.7 86Z',
				age:
					'M52.7 80.6556C52.7 80.6556 83.9144 62.1667 115.7 62.1667C146.9144 62.1667 146.8747 71.3176 178.7 75.8889C209.8747 80.3667 241.7 80.3667 241.7 80.3667L241.7 86L178.7 86L115.7 86L52.7 86Z'
			}
			return `
			<svg width="189" height="26" viewBox="50 60 189 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="${pathMap[this.type]}" fill="#040B29" fill-opacity="0.1"></path>
</svg>
`
		}
	},
	methods: {
		onSliderChange(e) {
			const sliderRanges = e

			this.inputRanges = [
				this.transferSliderToInput(sliderRanges[0], 0),
				this.transferSliderToInput(sliderRanges[1], 1)
			]

			this.$emit(
				'update:range',
				this.inputRanges.map(val => {
					return Number.isNaN(parseInt(val)) ? null : parseInt(val)
				})
			)
		},
		onInputChange(e, idx) {
			this.$nextTick(() => {
				const numValue = parseInt(this.inputRanges[idx])
				if (!this.inputRanges[idx].length) {
					// 如果输入空字符串
					this.inputRanges[idx] = null
				} else if (Number.isNaN(numValue)) {
					// 输入非法
					this.inputRanges[idx] = this.cacheInputRages[idx]
				} else if (numValue <= this.sourceRanges[0].from) {
					// 越界
					this.inputRanges[idx] = null
				} else if (numValue >= this.sourceRanges[this.sourceRanges.length - 1].to) {
					// 越界
					this.inputRanges[idx] = null
				} else if (idx === 0 && numValue > this.sliderRanges[1]) {
					// 错位
					this.inputRanges[idx] = '' + this.sliderRanges[1]
				} else if (idx === 1 && numValue < this.sliderRanges[0]) {
					// 错位
					this.inputRanges[idx] = '' + this.sliderRanges[0]
				}

				this.sliderRanges = [
					this.transferInputToSlider(this.inputRanges[0], 0),
					this.transferInputToSlider(this.inputRanges[1], 1)
				]

				if (this.inputRanges[idx] !== this.cacheInputRages[idx]) {
					this.$emit(
						'update:range',
						this.inputRanges.map(val => {
							return Number.isNaN(parseInt(val)) ? null : parseInt(val)
						})
					)
				}
			})
		},

		transferInputToSlider(inputNum, pos) {
			if (inputNum === null) {
				if (pos === 0) {
					return this.sourceRanges[0].from
				} else {
					return this.sourceRanges[this.sourceRanges.length - 1].to
				}
			}

			return parseInt(inputNum)
		},
		transferSliderToInput(sliderNum, pos) {
			if (pos === 0 && sliderNum <= this.sourceRanges[0].from) {
				return null
			}

			if (pos === 1 && sliderNum >= this.sourceRanges[this.sourceRanges.length - 1].to) {
				return null
			}

			return sliderNum + ''
		}
	},
	watch: {
		range(range) {
			if (!range) {
				this.sliderRanges = [
					this.sourceRanges[0].from,
					this.sourceRanges[this.sourceRanges.length - 1].to
				]
				this.inputRanges = [null, null]

				this.cacheInputRages = this.inputRanges.concat()
			} else {
				this.inputRanges = range.map(v => (v === null ? null : v + ''))
				this.sliderRanges = [
					this.transferInputToSlider(this.inputRanges[0], 0),
					this.transferInputToSlider(this.inputRanges[1], 1)
				]

				this.cacheInputRages = this.inputRanges.concat()
			}
		}
	}
}
</script>

<style lang="scss">
@import '~@nio-fe/nio-app-ui/es/style';

.chart-ranger {
	.svg-wrapper {
		svg {
			width: 100%;
			height: 100%;
		}
	}

	.chart-axis {
		margin-top: 20px;
		margin-bottom: 10px;
		display: flex;
		justify-content: space-between;
		font-size: 12px;
	}

	.range-slider {
		margin-top: -5.5px;
		background-color: #e6e7ea;
		.van-slider__button {
			width: 20px;
			height: 20px;
			box-shadow: none;
			border: 2px solid #040b29;
		}

		.van-slider__bar {
			background-color: #040b29;
		}
	}

	.range-input-row {
		margin-top: 20px;
		display: flex;
		align-items: center;

		> span {
			margin: 0 5px;
		}

		.range-input {
			flex: 1;
			min-width: 0;
			height: 45px;
			border: 1px solid #e9ecf1;
			display: flex;
			align-items: center;

			input {
				width: 100%;
				text-align: center;
				border: none;
				font-size: 14px;

				&:active {
					border: none;
				}

				&::-webkit-input-placeholder {
					color: $text_disable;
					font-size: 14px;
				}
			}
		}
	}
}
</style>
